// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3jGHY","requiredAsterisk":"Info_requiredAsterisk__2p_SW"};